import axios from 'axios';
import api from '../BaseReq';

export default axios.create({
    baseURL: `${api.defaults.baseURL}manage-calculations/`
});